import { BroadcastService } from './BroadcastService';
import { ImageGrabService } from './ImageGrabService';
import { LiveService } from './LiveService';
import { LocalStorageService } from './LocalStorageService';
import { MemoryStorageAccessor } from './MemoryStorageAccessor';
import { PermissionService } from './PermissionService';
import { SessionStorageService } from './SessionStorageService';
import { TokenService } from './TokenService';
import { UrlPath } from './UrlPath';
import { UserService } from './UserService';
import { VersionsService } from './VersionsService';

export class ServicesProviderFactory {
	addProviderTypes(dependencies: any[]) {
		dependencies.push({ provide: BroadcastService, useClass: BroadcastService });
		dependencies.push({ provide: ImageGrabService, useClass: ImageGrabService });
		dependencies.push({ provide: LiveService, useClass: LiveService });
		dependencies.push({ provide: LocalStorageService, useClass: LocalStorageService });
		dependencies.push({ provide: MemoryStorageAccessor, useClass: MemoryStorageAccessor });
		dependencies.push({ provide: PermissionService, useClass: PermissionService });
		dependencies.push({ provide: SessionStorageService, useClass: SessionStorageService });
		dependencies.push({ provide: TokenService, useClass: TokenService });
		dependencies.push({ provide: UrlPath, useClass: UrlPath });
		dependencies.push({ provide: UserService, useClass: UserService });
		dependencies.push({ provide: VersionsService, useClass: VersionsService });
	}
}
